function BetaBanner() {
  return (
    <div className="w-full grid grid-cols-1">
      <p className="mx-auto text-red-400">THIS PROJECT IS CURRENTLY IN BETA</p>
    </div>
  )
}

export default BetaBanner